var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        switch: true,
        questionActive: _vm.questionIsActive,
        ["size-" + _vm.size]: true,
      },
    },
    [
      _c("input", {
        attrs: { type: "checkbox", disabled: _vm.isDisable },
        domProps: { checked: _vm.value },
        on: { change: (e) => _vm.onChange(e.target.checked, _vm.id) },
      }),
      _vm._m(0),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "border" }, [
      _c("span", { staticClass: "containerCircle" }, [
        _c("span", { staticClass: "circle" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }